document.addEventListener("DOMContentLoaded", () => {

    const container = document.getElementById("nereo-particles");

    if(!container) return;

    const TOTAL = 40;

    function createParticle(){

        const rect = container.getBoundingClientRect();

        const p = document.createElement("span");

        p.className = "nereo-particle";

       const size = Math.random()*5 + 3;

        p.style.width = size + "px";
        p.style.height = size + "px";

        p.style.left = Math.random()*rect.width + "px";
        p.style.top = rect.height + 40 + "px";

        const duration = Math.random()*5 + 8;

        const glow = Math.random()*18 + 15;

        p.style.boxShadow = `
0 0 ${glow}px rgba(139,195,74,.95),
0 0 ${glow*2}px rgba(139,195,74,.35),
0 0 ${glow*3}px rgba(139,195,74,.12)
`;

        container.appendChild(p);

        p.animate([
            {
                transform:"translate(0,0) scale(.4)",
                opacity:0
            },
            {
                opacity:.9,
                offset:.15
            },
            {
                transform:`translate(${(Math.random()*140)-70}px,-${rect.height+120}px) scale(1.7)`,
                opacity:.15
            },
            {
                opacity:0
            }

        ],{

            duration:duration*1000,
            easing:"ease-out"

        });

        setTimeout(()=>{
            p.remove();
            createParticle();
        },duration*1000);

    }

    for(let i=0;i<TOTAL;i++){

        setTimeout(createParticle,i*180);

    }

});